import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import React, { useContext, useEffect, useState } from "react";
import propTypes from "prop-types";

import { api, Booking, Complaint, ComplaintType, IComplaintsList, SourceApp } from "../../../logic/api";

import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";

import { SessionContext } from "../../../utility/useSession";
import { useDate } from "../../../utility/useDate";

import { BookingComplaint } from "../BookingComplaint/BookingComplaint";
import { useTranslation } from "react-i18next";

export const BookingComplaints: React.FunctionComponent<{ booking: Booking, show: boolean, onHide: (didSaveComplaint: boolean) => void }> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const [complaintParams, setComplaintParams] = useState<IComplaintsList>({ bookingId: props.booking.id });
    const [showComplaint, setShowComplaint] = useState(false);
    const [complaint, setComplaint] = useState<Complaint | null>(null);
    const [didSaveComplaint, setDidSaveComplaint] = useState<boolean>(false);
    const { localizeDate, toFormattedDateTimeString } = useDate();

    useEffect(() => {
        setComplaintParams({ ...complaintParams, bookingId: props.booking.id });
    }, [props.booking.id]);

    return <Dialog open={props.show} fullWidth={true} maxWidth="sm"  >
        <DialogTitle>
            {t("menuItems.complaints")}
        </DialogTitle>
        <DialogContent>
            {complaint != null && (
                <BookingComplaint complaint={complaint} show={showComplaint} onHide={(saved) => {
                    setShowComplaint(false);
                    setDidSaveComplaint(saved);
                    if (saved) {
                        setComplaintParams({ ...complaintParams });
                    }
                }}></BookingComplaint>
            )}

            <PagedDataView<IComplaintsList, Complaint>
                apiHook={api.hooks.complaint.list}
                parameters={complaintParams}

                renderItem={(item) => {
                    let complaintType = t("complaints.damageAndService");
                    if (item.complaintType == ComplaintType.service) {
                        complaintType = t("complaints.service");
                    } else if (item.complaintType == ComplaintType.damage) {
                        complaintType = "Damage complaint";
                    }
                    return <div
                        style={{ padding: 10, border: "solid 1px #eee", borderRadius: 7, marginBottom: "10px", cursor: "pointer" }}
                        onClick={() => {
                            setComplaint({ ...item, booking: props.booking });
                            setShowComplaint(true);
                        }}
                    >
                        <div><b>{complaintType}</b></div>
                        <div>{toFormattedDateTimeString(new Date(item.complaintDate))}</div>
                    </div>
                }}
            >
                {t("complaints.noneFound")}
            </PagedDataView>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => {
                setComplaint({
                    booking: props.booking, source: SourceApp.frontEnd,
                    leadPersonName: props.booking.leadContact.fullName,
                    email: props.booking.leadContact.email,
                    phoneMobile: props.booking.leadContact.phoneMobile,
                    deviceSerialNo: "Front End",
                    complaintType: ComplaintType.serviceAndDamage,
                    createdBy: session.current.site?.user,
                    complaintDate: localizeDate(new Date()).toISO()
                } as Complaint);
                setShowComplaint(true);
            }} color="secondary">
                {t("complaints.new")}
            </Button>
            <Button onClick={() => props.onHide(didSaveComplaint)} color="secondary">
                {t("general.done")}
            </Button>
        </DialogActions>
    </Dialog>
};

BookingComplaints.propTypes = {
    booking: propTypes.any.isRequired,
    show: propTypes.bool.isRequired,
    onHide: propTypes.any.isRequired
};